import 'underscore';

var initialState = {
    itemCondition: null,
    validationError: null,
    selectionError: null
};

function validate(newState) {
    newState.validationError =
        newState.itemCondition == null ||
        newState.itemCondition.trim() == '' ||
        newState.itemCondition === 'Undefined'
            ? 'syi_validation_missing_condition'
            : newState.selectionError;

    return newState;
}

export default (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case 'SET_ITEM_CONDITION':
            return validate(
                _.assign({}, state, { itemCondition: action.payload })
            );
        case 'RESET_ITEM_CONDITION':
            return validate(_.assign({}, initialState));
        case 'SET_ITEM_CONDITION_SELECTION_ERROR':
            return validate(
                _.assign({}, state, {
                    selectionError: action.payload
                })
            );
        default:
            return state;
    }
};
